import { ReactComponent as CheckmarkGlyph } from '@/assets/images/svg/glyphs/checkmark-thick.svg';
import { ReactComponent as XGlyph } from '@/assets/images/svg/glyphs/x.svg';
import { Column, Grid, Header, HeaderWrapper, Row } from '@/components/tables/ComparisonTable/components';
import { COLORS } from '@/styles/color';
import { FC, Fragment, ReactNode } from 'react';

interface ComparisonTableProps extends PropsWithClassName {
  columns: {
    header: string | ReactNode;
    rows: {
      text: string;
      enabled: boolean;
    }[];
  }[];
}

const ComparisonTable: FC<ComparisonTableProps> = (props) => {
  return (
    <Grid className={props.className}>
      {props.columns.map((column, index) => (
        <Fragment key={`${column.header}-${index}`}>
          <HeaderWrapper
            data-header-index={index}
            {...(index === 0 ? { 'data-first-header': true } : {})}
            {...(index + 1 === props.columns.length ? { 'data-last-header': true } : {})}
          >
            {typeof column.header === 'string' ? <Header>{column.header}</Header> : column.header}
          </HeaderWrapper>

          <Column
            data-column-index={index}
            {...(index === 0 ? { 'data-first-column': true } : {})}
            {...(index + 1 === props.columns.length ? { 'data-last-column': true } : {})}
          >
            {column.rows.map((row, index) => (
              <Row key={`${row.text}-${index}`}>
                {row.enabled ? (
                  <CheckmarkGlyph color={COLORS.GREEN.BASE} width={16} />
                ) : (
                  <XGlyph color={COLORS.ORANGE.LOWLIGHT} width={16} height={14} />
                )}
                <p>{row.text}</p>
              </Row>
            ))}
          </Column>
        </Fragment>
      ))}
    </Grid>
  );
};

export default ComparisonTable;
